import { Box } from "@mui/material";

import { withForm } from "components/Forms/AppForm";

import { pcmFormDefaultValues } from "./pcmFormDefaultValues";

const PcmDetailsSection = withForm({
  defaultValues: pcmFormDefaultValues,
  props: {
    vendorName: "",
  },
  render: function Render({ form, vendorName }) {
    return (
      <Box sx={{ mb: 4 }}>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          gap={2}
          mb={2}
        >
          <Box flex={1}>
            <form.AppField name="phone1">
              {(field) => <field.TextInput label="Phone Number" />}
            </form.AppField>
          </Box>
          <Box flex={1}>
            <form.AppField name="vendor">
              {(field) => (
                <field.TextInput label="Vendor" disabled value={vendorName} />
              )}
            </form.AppField>
          </Box>
        </Box>
        <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={2}>
          <Box flex={1}>
            <form.AppField name="custemail">
              {(field) => (
                <field.TextInput label="Email" type="email" required />
              )}
            </form.AppField>
          </Box>
          <Box flex={1}>
            <form.AppField name="custuname">
              {(field) => (
                <field.TextInput
                  label="Full Name"
                  placeholder="John Smith"
                  required
                />
              )}
            </form.AppField>
          </Box>
        </Box>
      </Box>
    );
  },
});

export default PcmDetailsSection;
